<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="settings icon"></i>
      {{ $t("automation configuration") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/automation.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description">
        <!-- <div class="ui two item top attached tabular menu" ref="tabs">
          <div class="item" data-tab="engines">
            <i class="code icon"></i> {{ $t("engines") }}
          </div>
          <div class="item" data-tab="grouping">
            <i class="cubes icon"></i> {{ $t("grouping") }}
          </div>
        </div> -->
        <!-- <div class="ui bottom attached tab segment" data-tab="engines">
          <engines ref="engines" />
        </div> -->
        <!-- <div class="ui bottom attached tab segment" data-tab="grouping"> -->
        <groups ref="groups" />
        <!-- </div> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  // local_api,
  enterprise_setup,
  // init_ajax_data_datables,
  // error_toast,
  // success_toast,
  // register_listener,
} from "@/utils";
// import Engines from "./Engines";
import Groups from "./Groups";
// import GenericModal from "@/components/GenericModal";
// import GenericContainer from "@/components/GenericContainer";
// import { v4 } from "uuid";

export default {
  components: {
    // Engines,
    Groups,
    // "generic-modal": GenericModal,
    // "generic-container": GenericContainer,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {};
  },
  methods: {
    show_modal(/* options */) {
      let vm = this;
      // if (options) {
      //   vm.target_template_id = options.target_template_id;
      //   local_api(
      //     vm,
      //     "post",
      //     "/staff_rating/teacher/do-get-evaluation-template",
      //     { i: options.target_template_id },
      //   )
      //     .then((evaluation_template) => {
      //       if (evaluation_template) {
      //         vm.evaluation_template = evaluation_template;
      //       } else {
      //         error_toast(vm.$t("evaluation mode not configured yet"));
      //       }
      //     })
      //     .catch((err) => {
      //       error_toast(err);
      //     });
      // }
      // console.log(options);

      // vm.init();

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.target_user_id = "";
            vm.ratings = [];
            vm.responses = [];
          },
          onShow() {
            window.jQuery(vm.$refs.tabs).find(".item").tab();
            vm.$refs.groups.init();
          },
        })
        .modal("show");
    },
    // create() {
    //   let vm = this;
    //   vm.$alertify.prompt(
    //     vm.$t("enter category name"),
    //     "",
    //     function (element, value) {
    //       local_api(vm, "post", "/product_category/do-simple-create", {
    //         n: value,
    //       })
    //         .then(() => {
    //           // vm.init();
    //         })
    //         .catch((err) => {
    //           error_toast(err);
    //         });
    //     },
    //   );
    // },
  },
  mounted() {
    // let vm = this;
    // local_api(vm, "post", "/product_categories/do-get-all")
    //   .then((conf) => {
    //     if (conf && conf.setup && conf.setup.phone_types)
    //       vm.phone_types = conf.setup.phone_types;
    //     if (conf && conf.setup && conf.setup.templates)
    //       vm.templates = conf.setup.templates;
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  },
  watch: {},
  updated: function () {
    // this.$nextTick(function () {});
  },
};
</script>
